import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/context/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import AssetDetail from "@/pages/AssetDetail";
import Checkout from "@/pages/Checkout";
import Library from "@/pages/Library";
import ContributorStudio from "@/pages/ContributorStudio";
import AdminConsole from "@/pages/AdminConsole";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/browse" element={<Browse />} />
                  <Route path="/asset/:id" element={<AssetDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route
                    path="/library"
                    element={
                      <ProtectedRoute>
                        <Library />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/studio"
                    element={
                      <ProtectedRoute roles={["contributor", "admin"]}>
                        <ContributorStudio />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin"
                    element={
                      <ProtectedRoute roles={["admin"]}>
                        <AdminConsole />
                      </ProtectedRoute>
                    }
                  />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
